import React from 'react';
import { useLocation } from 'react-router-dom';
import './Confirmation.css';
import ProgressBar from './ProgressBar';

function Confirmation() {
    const location = useLocation();

    // Check if booking details are available
    if (!location.state || !location.state.bookingDetails) {
        return <p>Booking details not found.</p>;
    }

    const { room, guests, bookingDetails, paymentMethod } = location.state;

    return (
        <div className="confirmation-page">
            <ProgressBar currentStep="confirmation" />
            <div className="confirm-container">
                <div className="confirm-message">
                    <p>Your booking has been submitted successfully. We just sent you a confirmation email to {bookingDetails.email}.</p>
                </div>
                <div className="confirm-details">
                    <h2>Booking Details</h2>
                    <div className="confirm-detail-item">
                        <span className="confirm-detail-label">Transaction ID:</span>
                        <span className="confirm-detail-value">{Math.floor(Math.random() * 100000000)}</span>
                    </div>
                    <div className="confirm-detail-item">
                        <span className="confirm-detail-label">Email:</span>
                        <span className="confirm-detail-value">{bookingDetails.email}</span>
                    </div>
                    <div className="confirm-detail-item">
                        <span className="confirm-detail-label">City:</span>
                        <span className="confirm-detail-value">{bookingDetails.city}</span>
                    </div>
                    <div className="confirm-detail-item">
                        <span className="confirm-detail-label">Room:</span>
                        <span className="confirm-detail-value">{room.name}</span>
                    </div>
                    <div className="confirm-detail-item">
                        <span className="confirm-detail-label">Guests:</span>
                        <span className="confirm-detail-value">{guests} (1 Adults + 0 Children)</span>
                    </div>
                    <div className="confirm-detail-item">
                        <span className="confirm-detail-label">Check In:</span>
                        <span className="confirm-detail-value">{new Date(room.checkIn).toLocaleDateString()}</span>
                    </div>
                    <div className="confirm-detail-item">
                        <span className="confirm-detail-label">Check Out:</span>
                        <span className="confirm-detail-value">{new Date(room.checkOut).toLocaleDateString()}</span>
                    </div>
                    <div className="confirm-detail-item">
                        <span className="confirm-detail-label">Payment:</span>
                        <span className="confirm-detail-value">{paymentMethod}</span>
                    </div>
                    <div className="confirm-detail-item">
                        <span className="confirm-detail-label">Total Price:</span>
                        <span className="confirm-detail-value">${room.totalPrice.toFixed(2)}</span>
                    </div>
                </div>
                <div className="confirm-actions">
                    <button onClick={() => window.print()}>Print Booking Details</button>
                    <button onClick={() => window.location.href = '/'}>Return to Home Page</button>
                </div>
            </div>
        </div>
    );
}

export default Confirmation;
